import {getCustomerStyles} from "./DataGetter";

const defaultStyles = {};

const loadedStyles = {};

export function setPositionStyles(positionId, styles) {
	loadedStyles[positionId] = styles;
}

export function getStyle(positionId, className, customerName) {
	if (loadedStyles[positionId] !== undefined) {
		return loadedStyles[positionId]
			.filter((s) => s.class === className)
			.reduce((carry, item) => ({ ...carry, [item['property']]: item['value'] }), {});
	}

	// dunno why, but whatever
	if (className === 'banner-background-img' && !templateAvailable(customerName)) {
		return 'default';
	}

	if (defaultStyles[customerName] !== undefined) {
		return defaultStyles[customerName]
			.filter((s) => s.class === className)
			.reduce((carry, item) => ({ ...carry, [item['property']]: item['value'] }), {});
	}

	return {};
}

export function templateAvailable(customerName) {
	return defaultStyles[customerName] !== undefined && Object.keys(defaultStyles[customerName]).length > 0;
}

export async function setStyle(customerName) {
	if (!Object.hasOwn(defaultStyles, customerName)) {
		// first load,
		await getCustomerStyles(customerName)
			.then((response) => response.json())
			.then((json) => defaultStyles[customerName] = json.base);
	}
}
